const toLocalizedUploadHtml = (html, attr) => {
  if (!html) {
    return html
  }

  const relativePattern = new RegExp(
    `${attr}=(["'])https?:\\/\\/[^"']*\\/htbcontent\\/uploads\\/`,
    "g"
  )

  return html.replace(relativePattern, `${attr}=$1/htbcontent/uploads/`)
}

export const normalizeWordPressHtml = html => {
  if (!html) {
    return html
  }

  let nextHtml = html

  nextHtml = toLocalizedUploadHtml(nextHtml, "src")
  nextHtml = toLocalizedUploadHtml(nextHtml, "href")

  return nextHtml
}
